import {
  GET_ME,
  LOADING_UPDATE_USER_PASS,
  SET_USER_PROFILE_IMGAE,
  LOADING_UPDATE_USER,
  SET_CURRENT_USER,
  SET_AUTH_TOKEN,
  SET_SHOW_OTP,
  SET_USER_SCORE,
  SET_LOADING_LOGOUT,
  SET_RESETPASS_NATIONALCODE,
  SET_SHOW_NATIONALCODE_DIALOG,
  SET_NATIONAL_CODE_OTP,
  SET_USER_LEVEL,
  SET_MAX_SCORE,
  SET_MIN_SCORE,
  SOUND_MUTED,
  SET_CHECK_USER_INFO,
  SHOW_REGISTER,
  REGISTER_CURRENT_STEP,
  LOADING_REGISTER,
  SUGGESTED_USER_DATA,
  SET_USER_POINT,
} from "../../constants/ActionTypes";

export const setCheckUserInfo = (userInfo) => {
  return (dispatch) => {
    dispatch({
      type: SET_CHECK_USER_INFO,
      payload: userInfo,
    });
  };
};

export const setRegisterCurrentStep = (currStepNum) => {
  return (dispatch) => {
    dispatch({
      type: REGISTER_CURRENT_STEP,
      payload: currStepNum,
    });
  };
};

export const setLoadingRegister = (loading) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_REGISTER,
      payload: loading,
    });
  };
};

export const setShowRegister = (show) => {
  return (dispatch) => {
    dispatch({
      type: SHOW_REGISTER,
      payload: show,
    });
  };
};

export const getMe = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_ME,
      payload: data,
    });
  };
};
export const setCurrentUser = (user) => {
  return (dispatch) => {
    dispatch({
      type: SET_CURRENT_USER,
      payload: user,
    });
  };
};
export const setAuthToken = (token) => {
  return (dispatch) => {
    dispatch({
      type: SET_AUTH_TOKEN,
      payload: token,
    });
  };
};
export const setLoadingUpdateUserPass = (loading) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_UPDATE_USER_PASS,
      payload: loading,
    });
  };
};
export const setUserProfileImage = (profileImage) => {
  return (dispatch) => {
    dispatch({
      type: SET_USER_PROFILE_IMGAE,
      payload: profileImage,
    });
  };
};
export const setLoadingUpdateUser = (loading) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_UPDATE_USER,
      payload: loading,
    });
  };
};
export const setShowOtp = (show) => {
  return (dispatch) => {
    dispatch({
      type: SET_SHOW_OTP,
      payload: show,
    });
  };
};
export const setUserScore = (score) => {
  return (dispatch) => {
    dispatch({
      type: SET_USER_SCORE,
      payload: score,
    });
  };
};
export const setLoadingLogout = (loading) => {
  return (dispatch) => {
    dispatch({
      type: SET_LOADING_LOGOUT,
      payload: loading,
    });
  };
};
export const setResetPassNationalCode = (nationalCode) => {
  return (dispatch) => {
    dispatch({
      type: SET_RESETPASS_NATIONALCODE,
      payload: nationalCode,
    });
  };
};
export const setShowNationalCodeDialog = (show) => {
  return (dispatch) => {
    dispatch({
      type: SET_SHOW_NATIONALCODE_DIALOG,
      payload: show,
    });
  };
};
export const setNationalCodeOtp = (code) => {
  return (dispatch) => {
    dispatch({
      type: SET_NATIONAL_CODE_OTP,
      payload: code,
    });
  };
};
export const setUserLevel = (level) => {
  return (dispatch) => {
    dispatch({
      type: SET_USER_LEVEL,
      payload: level,
    });
  };
};
export const setMaxScore = (score) => {
  return (dispatch) => {
    dispatch({
      type: SET_MAX_SCORE,
      payload: score,
    });
  };
};
export const setMinScore = (score) => {
  return (dispatch) => {
    dispatch({
      type: SET_MIN_SCORE,
      payload: score,
    });
  };
};

export const setSoundMuted = (soundmuted) => {
  return (dispatch) => {
    dispatch({
      type: SOUND_MUTED,
      payload: soundmuted,
    });
  };
};

export const setSuggestedUserData = (suggestedUserData) => {
  return (dispatch) => {
    dispatch({
      type: SUGGESTED_USER_DATA,
      payload: suggestedUserData,
    });
  };
};

export const setUserPoint = (point) => {
  return (dispatch) => {
    dispatch({
      type: SET_USER_POINT,
      payload: point,
    });
  };
};
